import React, { SVGProps } from "react";

export default function SupSum(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.75 5.25V3.25H4.25L10.25 10.75L5.25 16.75H15.75V14.75" stroke="currentColor" />
    </svg>
  );
}
